import React, { Component, createRef } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import UserService from '../../services/UserService';
import * as xlsx from 'xlsx';
import CountryService from '../../services/CountryService';
import CompanyMasterService from '../../services/CompanyMasterService';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { CSVLink, CSVDownload } from "react-csv";
import SecondaryReportService from '../../services/SecondaryReportService';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $, { contains } from 'jquery';
import jsPDF from 'jspdf';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';
import { TabView, TabPanel } from 'primereact/tabview';
import { FileUpload } from "primereact/fileupload";
import ReactDOM from 'react-dom';
import PrintSecondaryPackagingManualService from '../../services/PrintSecondaryManualPackagingService.js';
import NumberGenerationService from '../../services/NumberGenerationService';

// Manage Dealer data
export default class SecondaryManual extends Component {

    constructor(props) {
        super(props);
        this.ref = React.createRef()
        this.surveyLink = React.createRef();
        this.ApiService = new ApiService();
        this.SecondaryReportService = new SecondaryReportService();
        this.UserService = new UserService();
        this.CompanyMasterService = new CompanyMasterService();
        this.CountryService = new CountryService();
        this.handlePlantChange = this.handlePlantChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.NumberGenerationService = new NumberGenerationService();
        this.PrintSecondaryPackagingManualService = new PrintSecondaryPackagingManualService();
        this.tblResponse = new tableRequest();
        this.state = {
            allData: [],
            displayDetail: false,
            FromDate: new Date(),
            mappingfile: null,
            uploadImagPath: null,
            ToDate: new Date(),
            visible: false,
            uploaderDisabled: false,
            data: [],
            ReferenceID: '',
            updateLoader: false,
            sortIcon: false,
            UserName: '',
            MaterialCode: '',
            ship_City: '',
            ship_State: '',
            ship_Country: '',
            ship_Address1: '',
            ship_Address2: '',
            ship_Pincode: '',
            MaterialNumber: '',
            bill_City: '',
            bill_State: '',
            bill_Country: '',
            bill_Address1: '',
            bill_Address2: '',
            bill_Pincode: '',
            FromNo: '',
            SuccessCount: 0,
            ErrorCount: 0,
            errorList: [],
            ToNo: '',
            MaterialNumber: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ErrorCount: 0,
            SuccessCount: 0,
            isError: false,
            ConfirmPassword: '',
            IsActive: false,
            sortOrder: '1',
            UserType: 2,//distributor
            CompanyId: '',
            companyDDL: [],
            materialDDL: [],
            formError: {
                ship_Country: '',
                UserName: '',
                ship_City: '',
                ship_State: '',
                bill_City: '',
                bill_State: '',
                MaterialNumber: '',
                LastName: '',
                Password: '',
                bill_Country: '',
                Email: '',
                ConfirmPassword: '',
                MobileNo: '',
                bill_Pincode: '',
                bill_Address1: '',
                bill_Address2: '',
                ship_Pincode: '',
                ship_Address1: '',
                ship_Address2: '',
                CompanyId: ''
            },

            formHeading: 'Add Retailer',
            buttonLabel: 'Submit',
            sales: [],
            ship_citySelectItems: [],
            ship_stateSelectItems: [],
            ship_countrySelectItems: [],
            bill_citySelectItems: [],
            bill_stateSelectItems: [],
            bill_countrySelectItems: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            compDisabled: false
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.SameAsBilling = this.SameAsBilling.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.FilterData = this.FilterData.bind(this);
        this.submitForm1 = this.submitForm1.bind(this);
        // this.mySelector = this.mySelector.bind(this);
        this.submitForm2 = this.submitForm2.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.hideFunc1 = this.hideFunc1.bind(this);
        this.onPage = this.onPage.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.openDialog1 = this.openDialog1.bind(this);
        this.onSort = this.onSort.bind(this);
        this.GetReportExport = this.GetReportExport.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {



        setTimeout(() => {
            var date = new Date();
            date.setDate(date.getDate() - 7);
            this.tblResponse.FromDate = date.toLocaleDateString();
            this.tblResponse.ToDate = new Date().toLocaleDateString();
            this.tblResponse.Company =
                this.tblResponse.MaterialCode =
                this.setState({
                    FromDate: date,
                    ToDate: new Date()
                });
            this.GetUsers();
            this.GetCompany();
            this.GetMaterialCode();
        }, 1000);
        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');


        });


    }
    onChange = date => this.setState({ FromDate: '', ToDate: '' })
    //loading page 
    onPage(event) {


        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetUsers();
            this.GetCompany();
            this.GetMaterialCode();
        }, 250);
    }
    FilterData() {
        ;
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.GetUsers();
    }
    handleFileChange = (event) => {
        debugger
        const files = event.target.files;
        if (files.length > 1) {
            // If more than one file is selected, alert the user
            alert("Please select only one file.");
            // Clear the selected files
            event.target.value = null;
            // Optionally, you can reset the state to clear any stored files
            this.setState({ mappingfile: null });
        } else {
            // Proceed with handling the selected file
            const selectedFile = files[0];
            // You can store the selected file in the component state if needed
            this.setState({ mappingfile: selectedFile });
        }
    }
    handleChange(event) {

        const { name, value } = event.target;
        switch (name) {
            case 'FromDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select from date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("From date must be less than to date.");
                        return;
                    }
                }

                break;
            case 'ToDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select to date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("To date must be greater than from date.");
                        return;
                    }
                }
            default:
                break;
        }

        this.setState({ [name]: value });
    }
    // get list data
    getLazyLoadingValues(event) {
        debugger;
        const fromDate = new Date(this.state.FromDate);
        const toDate = new Date(this.state.ToDate);
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        debugger
        this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.FromDate = fromDate.toLocaleDateString();
        this.tblResponse.ToDate = toDate.toLocaleDateString();
        this.tblResponse.Company = this.state.Company;
        this.tblResponse.MaterialCode = this.state.MaterialCode;
    }
    GetReportExport() {
        this.SecondaryReportService.GetReportExportManual(this.tblResponse).then(data => {
            const resdata = data.data;

            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({
                    allData: resdata.ResponseData
                });

                this.setState({ allData: resdata.ResponseData }, () => {
                    this.surveyLink.link.click()
                });
            }
        });
    }
    //to get country data
    GetCountry() {

        this.CountryService.GetCountries('101').then(data => {
            const resdata = data.data;
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.state.ship_countrySelectItems = resdata.ResponseData;
                this.state.bill_countrySelectItems = resdata.ResponseData;

            }
        });
    }

    SetState(cCode, fieldName) {


        if (fieldName == 'bill_Country') {
            const resdata = this.state.allstate.filter(x => x.CountryId == cCode);
            this.setState({
                "bill_stateSelectItems": resdata
            });

        }
        if (fieldName == 'ship_Country') {
            const resdata = this.state.allstate.filter(x => x.CountryId == cCode)
            this.setState({
                "ship_stateSelectItems": resdata
            });
        }
    }
    showErrorList() {
        this.setState({ displayDetail: true });
    }
    SetCity(sCode, fieldName) {
        if (fieldName == 'bill_State') {
            const resdata = this.state.allcity.filter(x => x.StateId == sCode);
            this.setState({
                "bill_citySelectItems": resdata
            });
        }
        if (fieldName == 'ship_State') {
            const resdata = this.state.allcity.filter(x => x.StateId == sCode);
            this.setState({
                "ship_citySelectItems": resdata
            });
        }
    }

    GetStates(cCode) {
        this.CountryService.GetStates(cCode).then(data => {
            const resdata = data.data;

            this.setState({
                "allstate": resdata.ResponseData,
                // "bill_stateSelectItems": resdata.ResponseData,
                // "ship_stateSelectItems": resdata.ResponseData
            });

            //    if(fieldName == 'bill_Country')
            //    this.setState({
            //         "bill_stateSelectItems" : resdata.ResponseData,
            //         "ship_stateSelectItems" : resdata.ResponseData
            //     });   

            //   if(fieldName == 'ship_Country')
            // this.setState({
            //      "ship_stateSelectItems" : resdata.ResponseData
            //  });


        });
    }

    GetCities(sCode) {
        this.CountryService.GetCities(sCode).then(data => {
            const resdata = data.data;
            this.setState({
                "allcity": resdata.ResponseData,
                // "bill_citySelectItems": resdata.ResponseData,
                // "ship_citySelectItems": resdata.ResponseData

            });
            //if(fieldName == 'bill_State')
            // this.setState({
            //      "bill_citySelectItems" : resdata.ResponseData,
            //      "ship_citySelectItems" : resdata.ResponseData
            //  });   

            // if(fieldName == 'ship_State')
            //  this.setState({
            //       "ship_citySelectItems" : resdata.ResponseData
            //   });
        });
    }

    // get users data list from api
    GetUsers() {
    
        this.SecondaryReportService.GetSecondaryManualMainReport(this.tblResponse).then(data => {
            const resdata = data.data;
            this.setState({ updateLoader: true });
            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false
                });

                //    if(tbl)
                //    {
                //     this.setState({
                //     allData: resdata.ResponseData
                //     });

                //     this.setState({ allData: resdata.ResponseData }, () => {
                //         this.surveyLink.link.click()
                //    });
                //    }

            }
            //if response data null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }
    handlePlantChange(event) {
        debugger
        this.tblResponse.Company = event.target.value
        this.setState({
            Company: event.target.value
        });
        this.GetUsers();
        this.GetMaterialCode();
    }
    handleCodeChange(event) {
        this.tblResponse.MaterialCode = event.target.value
        this.setState({
            MaterialCode: event.target.value
        });
        this.GetUsers();
    }
    // call every change of form and validation part also
    handleChange(event) {
        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
        //this statement will set state value for IsActive
        if (name == "IsActive")
            this.setState({
                IsActive: event.target.checked
            });
    }

    // call to update billing to shipping
    SameAsBilling(event) {
        if (event.target.checked) {
            this.setState({
                "ship_countrySelectItems": this.state.bill_countrySelectItems,
                "ship_stateSelectItems": this.state.bill_stateSelectItems,
                "ship_citySelectItems": this.state.bill_citySelectItems,
                "ship_Country": this.state.bill_Country,
                "ship_State": this.state.bill_State,
                "ship_City": this.state.bill_City,
                "ship_Address1": this.state.bill_Address1,
                "ship_Address2": this.state.bill_Address2,
                "ship_Pincode": this.state.bill_Pincode
            });

        }

    }
    validateForm(value, name) {

        let errors = this.state.formError;
        let IsValid = true;
        this.setState({ isError: false });
        //this switch case is used for each form field to validate
        switch (name) {

            case 'FromNo':
                if (value <= 0) {
                    IsValid = false;
                    errors.FromNo = "FromNo cannot be zero or negative.";
                    this.setState({ isError: true })
                }
                else if (value > this.state.refrenceToNo) {
                    IsValid = false;
                    errors.FromNo = "FromNo cannot be greater than ToNo.";
                    this.setState({ isError: true })
                }
                else if (value < this.state.refrenceFromNo) {
                    IsValid = false;
                    errors.FromNo = "FromNo cannot be greater than FromNo.";
                    this.setState({ isError: true })
                } else {
                    errors.FromNo = '';
                    this.setState({ isError: false })
                }

                break;
            case 'ToNo':
                if (value <= this.state.refrenceFromNo) {
                    IsValid = false;
                    errors.ToNo = "ToNo must be greater than FromNo.";
                    this.setState({ isError: true })
                } else if (value > this.state.refrenceToNo) {
                    IsValid = false;
                    errors.ToNo = "ToNo cannot be greater than the maximum allowed value.";
                    this.setState({ isError: true })
                } else {
                    errors.ToNo = '';
                    this.setState({ isError: false })
                }
                break;
        }

        return IsValid;
    }

    // Validate form

    openDialog1() {

        this.setState({ visible1: true, uploadImagPath: '' });
        this.formReset();
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true,
            ship_City: '',
            ship_State: '',
            ship_Country: '',
            ship_Address1: '',
            ship_Address2: '',
            ship_Pincode: '',
            bill_City: '',
            bill_State: '',
            bill_Country: '',
            bill_Address1: '',
            bill_Address2: '',
            bill_Pincode: '',


        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }

    hideFunc() {

        this.setState({
            visible: false, buttonLabel: 'Submit', isError: false,
            formHeading: 'Add Retailer'
        })
        this.formReset();
        this.GetUsers();
    }
    hideFunc1() {


        this.setState({
            SuccessCount: 0, ErrorCount: 0,
            visible1: false, buttonLabel: 'Submit',
            formHeading1: 'Upload File'
        })
        this.formReset();
        this.GetUsers();
        window.location.reload();
    }
    // open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
        this.state.ship_stateSelectItems = 0;
        this.state.bill_stateSelectItems = 0;
        this.state.ship_citySelectItems = 0;
        this.state.bill_citySelectItems = 0;
    }
    openDialog1() {
        this.setState({ visible1: true });
        this.formReset();

    }
    // submit form and create or update user
    submitForm(event) {

        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });

        if (isfrmvalid) {
            this.setState({ updateLoader: false });
            console.log(this.ship_City);
            const formData = {
                UserName: this.state.UserName,
                Id: this.state.Id,
                FirstName: this.state.FirstName,
                LastName: this.state.LastName,
                Email: this.state.Email,
                MobileNo: this.state.MobileNo,
                Password: this.state.Password,
                ReferenceID: this.state.ReferenceID,
                IsActive: this.state.IsActive,
                UserType: this.state.UserType,
                ship_City: this.state.ship_City.CityId,
                ship_State: this.state.ship_State.StateId,
                ship_Country: this.state.ship_Country.CountryId,
                ship_Pincode: this.state.ship_Pincode,
                ship_Address1: this.state.ship_Address1,
                ship_Address2: this.state.ship_Address2,
                bill_City: this.state.bill_City.CityId,
                bill_State: this.state.bill_State.StateId,
                bill_Country: this.state.bill_Country.CountryId,
                bill_Pincode: this.state.bill_Pincode,
                bill_Address1: this.state.bill_Address1,
                bill_Address2: this.state.bill_Address2,
                CompanyId: this.state.CompanyId.CompId
            }

            setTimeout(() => {
                this.UserService.CreateUpdateUser(formData).then(data => {

                    const resdata = data.data;
                    if (resdata !== null && resdata.RespCd === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });
                        this.formReset();
                        this.GetUsers()
                    } else if (resdata.RespCd === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });

                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });

                    }
                });
            }, 1000);
            $('.p-column-title').on('click', function () {
                $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
            });
        }
    }

    submitForm1(event) {
        event.preventDefault();
        const excelData = this.state.excelData
        if (!excelData) {
            // Handle the error, maybe display a message to the user
            this.refs.Messchild.showWarn("Upload Excel File!!");
        }
        else {
            var form = new FormData()
            // form.append('data', JSON.stringify(excelData))
            this.setState({ updateLoader: false, mappingfile: null, uploaderDisabled: true })
            this.UserService.UploadSecondaryManual(excelData).then(data => {

                this.setState({ loading: true, mappingfile: null, uploaderDisabled: false })
                const response = data.data;
                console.log(response)
                this.state.excelData = '';
                // this.stateuploadImagPath
                this.setState({ uploadImagPath: '', updateLoader: true, mappingfile: null, uploaderDisabled: true });
                this.setState({ updateLoader: false });
                this.setState({ mappingfile: null });

                //if response code is 200 success message else warning message
                if (response.ResponseCode === 200) {
                    this.errorList = response.ResponseData.ErrorList;
                    this.formReset();
                    this.setState({
                        loading: false,
                        fileToUpload: null,
                        //form : null,
                        // visible1: false,
                        updateLoader: true,
                        mappingfile: null,
                        uploadImagPath: null,

                        SuccessCount: response.ResponseData.SuccessCount,
                        ErrorCount: response.ResponseData.ErrorCount,
                    });

                    this.refs.Messchild.showSuccess(response.ResponseMessage);

                    if (response.ResponseData.ErrorCount > 0) {
                        this.ErrorCount = response.ResponseData.ErrorCount;
                        this.ErrorDetail = true
                        this.GetUsers();
                        this.exportErrorListToExcel(this.errorList);

                    }




                    if (response.ResponseData.SuccessCount != 0) {

                        this.SuccessCount = response.ResponseData.SuccessCount;
                        this.GetUsers();
                    }

                }


                else if (response.ResponseCode === 500) {

                    this.refs.Messchild.showWarn(response.RespMsg);
                    this.GetUsers();
                }
                else {

                    this.refs.Messchild.showWarn(response.RespMsg);
                }
                this.ref.clear()
            });
        }
    }
    exportErrorListToExcel(errorList) {
        debugger
        // Convert errorList to Excel file
        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(errorList);
        XLSX.utils.book_append_sheet(wb, ws, 'ErrorList');
        // Save Excel file
        XLSX.writeFile(wb, 'ErrorList.xlsx');
    }

    // mySelector(e) {
    //     debugger
    //     e.files.remove(0)
    // }

    myUploader(event) {
        const fileExt = event.files[0].name.split('.').pop().toLowerCase();
        const allowedExtensions = ['xls', 'xlsx'];
        this.setState({
            SuccessCount: 0,
            ErrorCount: 0,
        });

        if (!allowedExtensions.includes(fileExt)) {
            this.refs.Messchild.showError('File extension is not acceptable.');
            return;
        }
        if (event.files.length !== 1) {
            this.refs.Messchild.showError('Only one file should be uploaded.');
            return;
        }
        const fileToUpload = event.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const workbook = xlsx.read(e.target.result, { type: 'binary' });
            const firstSheet = workbook.SheetNames[0];
            const ws = workbook.Sheets[firstSheet];
            const firstRow = xlsx.utils.sheet_to_json(ws, { header: 1 })[0]; // Get the first row of the sheet
            // const excelRows = xlsx.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
            // if (excelRows.length === 0) {
            //     this.refs.Messchild.showError('Uploaded file does not contain any data.');
            //     return;
            // }
            const expectedHeaders = [
                "MaterialNumber",
                "MaterialName",
                "ChemicalName",
                "Plant",
                "StorageLocation",
                "BatchNumber",
                "ManufactureDate",
                "ExpiryDate",
                "ValuatedUnrestrictedStock",
                "PackQuantity",
                "NumberofCases",
                "UOM",
                "GW",
                "Contractor",
                "Supervisor",
                "DateOfPack"
               // "Remarks"
            ];

            //const excelHeaders = Object.keys(excelRows[0]); // Get headers from the Excel file

            if (!expectedHeaders.every(header => firstRow.some(excelHeader => typeof excelHeader === 'string' && excelHeader.toLowerCase() === header.toLowerCase()))) {
                this.refs.Messchild.showError('Uploaded file does not contain all required headers in correct format');
                return;
            }

            const excelRows = xlsx.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
            if (excelRows.length === 0) {
                this.refs.Messchild.showError('Uploaded file does not contain any data.');
                return;
            }
            const isEmptyRow = row => Object.values(row).every(value => value === '' || value === undefined || value === null);
            for (let i = 0; i < excelRows.length; i++) {
                if (isEmptyRow(excelRows[i])) {
                    this.refs.Messchild.showError('Uploaded file contains empty rows. Please upload again.');
                    return;
                }
            }
            // Set the Excel data to the state
            this.setState({ excelData: excelRows });
            // const ws = workbook.Sheets[firstSheet];
            this.data = xlsx.utils.sheet_to_json(ws, { header: 1 });
            this.refs.Messchild.showSuccess('File Uploaded Successfully.');
            console.log(excelRows);
        };

        reader.readAsBinaryString(fileToUpload);
    }

    submitForm2(event) {

        event.preventDefault();
        var rowData = [{
            "FromNo": this.state.FromNo,
            "ToNo": this.state.ToNo,
            "ProductName": this.state.ProductName,
            "CreatedDt": this.state.CreatedDt,
            "Plant": this.state.Plant,
            // "Qty": this.state.ToNo - this.state.FromNo + 1
            "Qty": this.state.Qty,
            "ManufactureDate": this.state.ManufactureDate,
            "ExpiryDate": this.state.ExpiryDate,
            "BatchNo": this.state.BatchNo,
            "GW": this.state.GW,
            "Supervisor": this.state.Supervisor,
            "Contractor": this.state.Contractor,
            "DateOfPack": this.state.DateOfPack,
           // "Remarks":this.state.Remarks
        }]
        event.preventDefault(); // Prevent default form submission behavior
        const { FromNo, ToNo } = this.state; // Destructure FromNo and ToNo from state

        // Call the service to update number generation with only FromNo and ToNo
        this.NumberGenerationService.UpdateNumber({ FromNo, ToNo });

        this.PrintSecondaryPackagingManualService.formPreview1(rowData);
        this.GetUsers();


    }
    // delete user data

    GetCompany() {

        this.CompanyMasterService.GetPlantDDL().then(data => {

            const resdata = data.data;

            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({
                    companyDDL: resdata.ResponseData,

                });






            }
        });
    }

    GetMaterialCode() {
        debugger
        const selectedPlant = this.tblResponse.Company || "";
        this.CompanyMasterService.GetMaterialCodeDDL(selectedPlant).then(data => {
            debugger
            const resdata = data.data;

            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({

                    materialDDL: resdata.ResponseData,

                });






            }
        });
    }
    // Search Filter
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetUsers();
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    // disabled check box
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }
    deleteUser(Id) {

        this.SecondaryReportService.DeleteManualRecord(Id).then(data => {
            const resdata = data.data;
            //if responsecode is 200 success message willl be shown else it will move to 'else statement'
            if (resdata.ResponseCode === '200') {
                this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                this.GetUsers();
                const totlrecord = this.state.totalRecords - 1;
                const row = this.state.rows;

                if (this.tblResponse.First >= totlrecord) {
                    const _curntCursor = Math.round(totlrecord / row);
                    this.tblResponse.First = _curntCursor + 1;
                }

            } else if (resdata.ResponseCode === '400') {
                this.refs.Messchild.showWarn(resdata.ResponseMessage);
            } else {
                this.refs.Messchild.showError(resdata.ResponseMessage);
            }
        });
    }
    // sort page 
    onSort(event) {
        debugger
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1, sortIcon: !this.state.sortIcon });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetUsers();
        const clickData = document.getElementsByClassName("p-sortable-column-icon pi pi-fw pi-sort");
        console.log(event);
    }

    // edit form 
    actionTemplate(rowData, column) {
        this.setState({ isError: false })
        const editMode = (e) => {
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update Retailer',
                visible: true, ReferenceID: rowData.ReferenceID,
                UserName: rowData.Username,
                Id: rowData.Id,
                FirstName: rowData.FirstName,
                LastName: rowData.LastName,
                Email: rowData.Email,
                MobileNo: rowData.MobileNo,
                Password: rowData.Password,
                ConfirmPassword: rowData.Password,
                IsActive: rowData.IsActive,
                ship_Address1: rowData.ship_Address1,
                ship_Address2: rowData.ship_Address2,
                ship_Pincode: rowData.ship_Pincode,
                bill_Address1: rowData.bill_Address1,
                bill_Address2: rowData.bill_Address2,
                bill_Pincode: rowData.bill_Pincode,

            });

            const CompanyObj = this.state.companyDDL.filter(x => x.CompId == rowData.CompanyId)

            const ship_CountryObj = this.state.ship_countrySelectItems.filter(x => x.CountryId == rowData.ship_Country)
            const bill_CountryObj = this.state.bill_countrySelectItems.filter(x => x.CountryId == rowData.bill_Country)

            this.state.ship_stateSelectItems = this.state.allstate;
            this.state.bill_stateSelectItems = this.state.allstate;
            this.state.ship_citySelectItems = this.state.allcity;
            this.state.bill_citySelectItems = this.state.allcity;
            const ship_CityObj = this.state.ship_citySelectItems.filter(x => x.CityId == rowData.ship_City)
            const bill_CityObj = this.state.bill_citySelectItems.filter(x => x.CityId == rowData.bill_City)
            const ship_StateObj = this.state.ship_stateSelectItems.filter(x => x.StateId == rowData.ship_State)
            const bill_StateObj = this.state.bill_stateSelectItems.filter(x => x.StateId == rowData.bill_State)



            this.setState({
                ship_Country: ship_CountryObj[0],
                bill_Country: bill_CountryObj[0],
                ship_State: ship_StateObj[0],
                bill_State: bill_StateObj[0],
                ship_City: ship_CityObj[0],
                bill_City: bill_CityObj[0],
                CompanyId: CompanyObj[0]
            });
        }

        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteUser(rowData.Id)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>
            <Button type="button" icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }

    actionTemplate(rowData, column) {
        const editMode = (e) => {

            this.setState({
                buttonLabel: 'Print', formHeading: 'Print Label',
                visible: true,
                Plant: rowData.Plant,
                MappingId: rowData.MappingId,
                ProductId: rowData.ProductID,
                ProductName: '' + rowData.ProductName,
                FromNo: '' + rowData.FromNo,
                ToNo: '' + rowData.ToNo,
                Qty: '' + rowData.Qty,
                refrenceFromNo: rowData.FromNo,
                refrenceToNo: rowData.ToNo,
                BatchNo: rowData.BatchNo,
                ManufactureDate: rowData.ManufactureDate,
                Id: rowData.Id,
                ExpiryDate: rowData.ExpiryDate,
                GW: rowData.GW,
                Supervisor: rowData.Supervisor,
                Contractor: rowData.Contractor,
                DateOfPack: rowData.DateOfPack,
              //  Remarks: rowData.Remarks,
                editMapping: rowData,
                Reason: '',
                MaterialNumber: rowData.MaterialNumber,
                CreatedDt: rowData.CreatedDt,
            });
            // this.PrintSecondaryPackagingManualService.formPreview1([rowData]);
            ////PRINT SLIP
        }
        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteUser(rowData.Id)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }
        return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }} ></Button>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;

    }
    // create html part
    //resolved KREP-36
    render() {
        let header = (
            <div className='row' style={{ 'textAlign': 'right' }}>
                <div className="col-md-9">
                    <form className="form-inline row">
                        <div className="col-md-7 d-flex flex-row flex-nowrap" style={{ gap: '5px' }}>
                            <div className="form-group">
                                <Calendar value={this.state.FromDate} name="FromDate" onChange={this.handleChange} appendTo={document.getElementById('root')} placeholder="From Date" />
                            </div>

                            <div className="form-group">
                                <Calendar value={this.state.ToDate} name="ToDate" onChange={this.handleChange} appendTo={document.getElementById('root')} placeholder="To Date" />
                            </div>
                            <button type="button" onClick={this.FilterData} className="btn btn-primary ml-3">Submit</button>
                        </div>

                        <div className='col-md-5 d-flex flex-row flex-nowrap' style={{ gap: '5px' }}>
                            <select id='plant' className='form-control w-50'
                                onChange={this.handlePlantChange} value={this.state.selectedPlant}>
                                <option value="0">Select All Plant</option>
                                {this.state.companyDDL.map(plant => (
                                    <option key={plant.Plant} value={plant.Plant}>{plant.Plant}</option>
                                ))}
                            </select>

                            <select id='product' className='form-control w-50'
                                onChange={this.handleCodeChange} value={this.state.selectedCode}>
                                <option value="0">Select All Product Code</option>
                                {this.state.materialDDL.map(MaterialCode => (
                                    <option key={MaterialCode.MaterialCode} value={MaterialCode.MaterialCode}>{MaterialCode.MaterialCode}</option>
                                ))}
                            </select>
                        </div>


                    </form>
                </div>

                <div className="col-md-3">
                    <div className="row text-right" >
                        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                        <InputText type="search" className='form-control' style={{ width: '60%' }} onInput={this.searchFilter} placeholder="Global Search" />
                        <button className="btn btn-primary ml-2 export-disabled"
                            target="_blank" disabled={this.state.sales == null} onClick={this.GetReportExport}>Export</button>
                        <CSVLink
                            hidden={true}
                            data={this.state.allData}
                            ref={(r) => this.surveyLink = r}
                            filename={"Secondary Packing Manual.csv"}
                        >
                        </CSVLink>
                    </div>
                </div>

            </div>
        );
        return (
            <>
                <MessageComponent ref="Messchild" />
                <Loaders loader={this.state.updateLoader} />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <div className='row'>
                        <div className='col-sm-7'>
                            <h1>Secondary Packing Manual</h1>
                        </div>
                        <div className='col-sm-5'>
                            <a className="btn btn-primary ml-2" icon="FaFileDownload" style={{ height: '34px' }} href={require('../../assets/ExcelTemplate/UploadSecondaryData.xlsx')} download="UploadSecondaryData.xlsx">Download Template </a>

                            <Button label="Upload " icon="pi pi-plus-circle" onClick={this.openDialog1} />
                        </div>
                    </div>
                </div>

                <DataTable exportFilename="Secondary Packing Report" responsive={true} header={header}
                    // globalFilter={this.state.globalFilter}
                    scrollable globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20, 50, 100]}
                    totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort} ref={(el) => { this.dt = el; }}>

                    <Column field="MaterialNumber" header="Product Code" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ProductName" header="Product Name" style={{ width: '250px' }} sortable="custom" />

                    <Column field="ProductDscrptn" header="Product Description" style={{ width: '250px' }} sortable="custom" />
                    {/* <Column field="FromNo" header="From No" style={{ width: '200px' }} sortable="custom" />
                    <Column field="ToNo" header="To No" style={{ width: '200px' }} sortable="custom" /> */}
                    <Column field="Plant" header="Plant" style={{ width: '100px' }} sortable="custom" />
                    <Column field="StorageLocation" header="Storage Location" style={{ width: '100px' }} sortable="custom" />
                    {/* <Column field="FromNo" header="From No." style={{ width: '100px' }} sortable="custom" />
                    <Column field="ToNo" header="To No." style={{ width: '100px' }} sortable="custom" /> */}
                    <Column field="BatchNo" header="Batch No" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ManufactureDate" header="Manufacture Date" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ExpiryDate" header="Expiry Date" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ValuatedUnrestrictedStock" header="Valuated Unrestricted Stock" style={{ width: '100px' }} sortable={false} />
                    <Column field="Qty" header="Pack Quantity" style={{ width: '100px' }} sortable="custom" />
                    <Column field="CreatedDt" header="Created Date" style={{ width: '150px' }} sortable={true} />
                    <Column field="NumberOfCases" header="No. of Cases" style={{ width: '100px' }} sortable={true} />
                    <Column field="GW" header="G.W." style={{ width: '100px' }} sortable={true} />
                    <Column field="Contractor" header="Contractor" style={{ width: '100px' }} sortable={true} />
                    <Column field="Supervisor" header="Supervisor" style={{ width: '100px' }} sortable={true} />
                    <Column field="DateOfPack" header="Date Of Pack" style={{ width: '100px' }} sortable={true} />
                    {/* <Column field="Remarks" header="Remarks" style={{ width: '100px' }} sortable={true} /> */}
                    <Column field="DownloadCount" header="Download/Print Count" style={{ width: '200px' }} sortable={true} />

                    <Column body={this.actionTemplate} header="Action" style={{ width: '100px' }} />
                </DataTable>

                <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                    <form onSubmit={this.submitForm2}>
                        <div className="form-padding">
                            <div className="row">
                                <div className="col-md-4 text-right">
                                    <label>Product Name<span>*</span>:</label>
                                </div>
                                <div className="col-md-8 mb-2">
                                    <input type="text" readOnly value={this.state.ProductName} onChange={this.handleChange} className="form-control" name="ProductName" />
                                    {this.state.formError.ProductName !== null ?
                                        <div className='error'>{this.state.formError.ProductName}</div> : null}
                                </div>

                                <div className="col-md-4 text-right">
                                    <label>Product Code<span>*</span>:</label>
                                </div>
                                <div className="col-md-8 mb-2">
                                    <input type="text" readOnly value={this.state.MaterialNumber} className="form-control" name="MaterialNumber" />
                                    {this.state.formError.MaterialNumber !== null ?
                                        <div className='error'>{this.state.formError.MaterialNumber}</div> : null}
                                </div>
                                <div className="col-md-4 text-right"><label>From No.<span>*</span>:</label></div>
                                <div className="col-md-8 mb-2">
                                    <input type="text" id="txtProductId" value={this.state.FromNo} onChange={this.handleChange} className="form-control" name="FromNo" />
                                    {this.state.formError.FromNo !== null ?
                                        <div className='error'>{this.state.formError.FromNo}</div> : null}
                                </div>



                                <div className="col-md-4 text-right"><label>To No.<span>*</span>:</label></div>
                                <div className="col-md-8 mb-2">
                                    <input type="text" value={this.state.ToNo} onChange={this.handleChange} className="form-control" name="ToNo" />
                                    {this.state.formError.ToNo !== null ?
                                        <div className='error'>{this.state.formError.ToNo}</div> : null}
                                </div>


                                <div className="col-md-12 text-center">
                                    <button disabled={this.state.isError} type="submit" className="btn btn-primary">{this.state.buttonLabel}</button>
                                </div>

                            </div>
                            <div>
                                <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                            </div>
                        </div>
                    </form>
                </Dialog>

                <Dialog
                    header={this.state.formHeading1}
                    blockScroll="true"
                    visible={this.state.visible1}
                    className="popup-modal"
                    modal={true}
                    onHide={this.hideFunc1}>
                    <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                        <TabPanel header="Upload Secondary File">
                            <form onSubmit={this.submitForm1} style={{ overflow: "hidden" }}>
                                <div className="row">
                                    <div className="col-md-4 text-right">
                                        <label>Upload Secondary File:</label>
                                    </div>
                                    <div className="col-md-8 mb-2">
                                        <label>Upload Excel(.xlsx or .xls):</label>
                                        <FileUpload ref={(e) => this.ref = e} name="mappingfile[]" value={this.state.mappingfile}
                                            customUpload uploadHandler={e => { this.myUploader(e, this) }}
                                            // onSelect={this.mySelector}
                                            accept=".xlsx" multiple={false} />
                                        {this.state.uploadImagPath ? (
                                            <div className="p-fileupload-row">                        <div>                          <img
                                                alt="file.xlsx"
                                                role="presentation"
                                                src={this.state.uploadImagPath}
                                                width="50"
                                            />                        </div>                      </div>) : null}
                                        {/* <a className="btn btn-primary mt-3 pt-2 pb-2" href={require('../../assets/ExcelTemplate/Mapping_details.xlsx')} download="Mapping_details.xlsx">Download Template </a> */}
                                        <div class="row" >
                                            <div class="col-md-6">
                                                <b>Success Count</b>
                                            </div>
                                            <div class="col-md-6">
                                                {this.state.SuccessCount}
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-md-6">
                                                <b>Error Count</b>
                                            </div>
                                            <div class="col-md-6">
                                                {this.state.ErrorCount}
                                            </div>



                                        </div>
                                        <button className="btn btn-primary mt-2" >Save</button>


                                    </div>
                                    <div>
                                        <label>
                                            Note: Fields marked as (
                                            <span style={{ color: "red" }}>*</span>) are required
                                        </label>
                                    </div>
                                </div>
                            </form>
                        </TabPanel>
                    </TabView>

                </Dialog>
            </>
        )
    }
}